import { ViolationApiResponse } from "@/TS/Interfaces/global_interfaces";

export const handleErrors = (
  errors: ViolationApiResponse[] | null | undefined,
  path: string,
) => {
  if (errors) {
    for (const error of errors) {
      if (error.propertyPath === path) {
        return { err: true, message: error.message };
      }
    }
    return { err: false };
  }
};
